<script setup>
  import ComponentMessage from "@components/Messages/Message.vue";
  import ComponentDashboard from "@pages/Dashboard/Components/Dashboard.vue";

  defineOptions({
    name: "PagesDashboardIndex",
  });
</script>

<template>
  <ComponentMessage display-mode="dashboard" />
  <ComponentDashboard :test-id="getTestId()" />
</template>
